import { render, staticRenderFns } from "./BottomOverlay.vue?vue&type=template&id=5f5178f0&scoped=true&"
import script from "./BottomOverlay.vue?vue&type=script&lang=js&"
export * from "./BottomOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BottomOverlay.vue?vue&type=style&index=0&id=5f5178f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5178f0",
  null
  
)

export default component.exports